<div class="betting-nav-bar">
  <span class="title">
    <img src="{{BETTING_TASKS}}" alt="" class="icon">
    Zadaci
  </span>
  <div class="right-side">
    <span *ngFor="let menuItem of bettingTasksMenuItems" class="tab-link" (click)="selectButton(menuItem.moduleName)"
      [ngClass]="isButtonSelected(menuItem.moduleName) ? 'is-active-tab-link' : 'tab-link'">
      {{menuItem.content}}
    </span>
    <button class="btn">
      <img alt="info Logo" src="{{INFO_WHITE}}" (click)="openInfoModal()" />
    </button>
  </div>
</div>